import React from "react";

export const GuidedJourneyContext = React.createContext();

export const IncentiveContext = React.createContext();